export default __webpack_public_path__ + "static/media/EmmaDwyer.51216731.png";